import { serverlog } from "@service/apiServices";
import { isWebView } from "@utils/commonUtils";
import { EWebViewActions } from "@utils/types";
import { useWebviewCallback } from "@utils/useWebviewCallback";
import { useEffect, useState } from "react";

export const useLocationPicker = () => {
  const [geoError, setGeoError] = useState(false);
  const [fetchingLocation, setFetchingLocation] = useState(false);
  const [locationFetched, setLocationFetched] = useState(false);
  const [position, setPosition] = useState({
    lat: null,
    lng: null,
  });
  const [locationAccess, setLocationAccess] = useState(false);
  const [permission, setPermission] = useState("");

  const promptLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        () => {
          setGeoError(false);
          setLocationAccess(true);
          serverlog("success propmted");
        },
        () => {
          setGeoError(true);
          setLocationAccess(false);
          serverlog("error propmted");
        }
      );
    } else {
      setGeoError(true);
      setLocationAccess(false);
      console.error("Geolocation is not supported");
    }
  };

  const getCurrentLocation = () => {
    setLocationFetched(false);
    const isApp = isWebView();
    if (isApp && !locationAccess) {
      useWebviewCallback(
        {
          action: EWebViewActions.ASK_LOCATION_PERMISSION,
          action_value: null,
        },
        () => {}
      );
      promptLocation();
      checkPermission();
      return;
    }
    if (navigator?.geolocation) {
      setFetchingLocation(true);
      const options = { timeout: 60000 };
      navigator.geolocation.getCurrentPosition(
        getLatLng,
        geoLocationError,
        options
      );
    } else {
      setGeoError(true);
      setFetchingLocation(false);
    }
  };

  useEffect(() => {
    locationFetched && setFetchingLocation(false);
  }, [locationFetched]);

  const getLatLng = async (position: any) => {
    const lat = position.coords.latitude;
    const lng = position.coords.longitude;

    setPosition({
      lat,
      lng,
    });
    setLocationFetched(true);
  };

  const checkPermission = () => {
    let navigator: any;
    if (typeof window !== "undefined") {
      navigator = window.navigator;
    }
    navigator.sayswho = (function () {
      const ua = navigator.userAgent;
      let tem;
      let M =
        ua.match(
          /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
        ) || [];
      if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return `IE "${tem[1] || ""}`;
      }
      if (M[1] === "Chrome") {
        tem = ua.match(/\b(OPR|Edge?)\/(\d+)/);
        if (tem != null)
          return tem
            .slice(1)
            .join(" ")
            .replace("OPR", "Opera")
            .replace("Edg ", "Edge ");
      }
      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];

      return M.join(" ");
    })();
    if (navigator.geolocation && navigator.permissions) {
      setGeoError(false);
      if (navigator.permissions) {
        navigator.permissions
          .query({
            name: "geolocation",
          })
          .then(function (result: any) {
            if (result.state === "granted") {
              setPermission("granted");
              setGeoError(false);
            } else if (result.state === "prompt") {
              setPermission("prompt");
              setGeoError(true);
            } else if (result.state === "denied") {
              setPermission("denied");
              setGeoError(true);
            }
          });
      }
    } else {
      setGeoError(true);
    }
  };

  const geoLocationError = () => {
    setGeoError(true);
    checkPermission();
    setLocationFetched(true);
  };

  return {
    getCurrentLocation,
    position,
    fetchingLocation,
    geoError,
    permission,
    locationFetched,
  };
};
